import React, { useState, useEffect } from 'react';
import { FiCheck, FiX, FiAlertCircle, FiInfo } from 'react-icons/fi';
import {
  ToasterContainer,
  Toast,
  ToastIcon,
  ToastContent,
  ToastCloseButton,
  ToastProgress,
} from './Toaster.styles';

const Toaster = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    // Listen for custom toast events
    const handleToast = (event) => {
      const { type, message, duration = 5000 } = event.detail;
      addToast(type, message, duration);
    };

    window.addEventListener('show-toast', handleToast);
    return () => window.removeEventListener('show-toast', handleToast);
  }, []);

  const addToast = (type, message, duration) => {
    const id = Date.now() + Math.random();
    const newToast = { id, type, message, duration };
    
    setToasts(prev => [...prev, newToast]);

    // Auto remove after duration
    setTimeout(() => {
      removeToast(id);
    }, duration);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const getToastIcon = (type) => {
    switch (type) {
      case 'success':
        return <FiCheck />;
      case 'error':
        return <FiX />;
      case 'warning':
        return <FiAlertCircle />;
      case 'info':
        return <FiInfo />;
      default:
        return <FiInfo />;
    }
  };

  return (
    <ToasterContainer>
      {toasts.map((toast) => (
        <Toast key={toast.id} type={toast.type}>
          <ToastIcon type={toast.type}>
            {getToastIcon(toast.type)}
          </ToastIcon>
          <ToastContent>{toast.message}</ToastContent>
          <ToastCloseButton onClick={() => removeToast(toast.id)}>
            <FiX />
          </ToastCloseButton>
          <ToastProgress type={toast.type} duration={toast.duration} />
        </Toast>
      ))}
    </ToasterContainer>
  );
};

// Helper function to show toasts
export const showToast = (type, message, duration) => {
  const event = new CustomEvent('show-toast', {
    detail: { type, message, duration }
  });
  window.dispatchEvent(event);
};

export default Toaster;
